import { Box, Button, Center, HStack } from "@chakra-ui/react";
import { useEffect } from "react";
import React from "react";
import Title from "../../../components/Title";
import { useNavigate } from "react-router-dom";
import { getUsers } from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/reducer/rootReducer";
import { User } from "../../../utils/types/user";
import { AppDispatch } from "../../../redux/store";
import MohUserManagement from "./mohAdmin";
import FacilityAdminUserManagement from "./facilityAdmin";
import CreateUserModal from "./createUser/createUserModal";
import { FaPlusCircle } from "react-icons/fa";

const UserManagement: React.FC = () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();
  const user: User | null = useSelector((state: RootState) => state.user.user);
  const [isCreateUserModalOpen, setIsCreateUserModalOpen] =
    React.useState(false);

  useEffect(() => {
    dispatch(getUsers());
  }, []);
  return (
    <Center display={"flex"} flexDirection={"column"}>
      <Box w={"70%"}>
        <HStack display={"flex"} justifyContent={"space-between"}>
          <Title
            title={"User Management"}
            onClick={() => {
              navigate("/");
            }}
          />
          {(user?.role.code === "FACAD" || user?.role.code === "MOHAD") && (
            <Button
              colorScheme="blue"
              size="md"
              fontWeight={"normal"}
              fontSize={14}
              leftIcon={<FaPlusCircle />}
              onClick={() => {
                setIsCreateUserModalOpen(true);
              }}
            >
              Create User
            </Button>
          )}
        </HStack>
        <CreateUserModal
          reloadTable={() => {
            dispatch(getUsers());
          }}
          isOpen={isCreateUserModalOpen}
          onClose={() => {
            setIsCreateUserModalOpen(false);
          }}
        />
        {user?.role.code === "FACAD" ? (
          <FacilityAdminUserManagement />
        ) : user?.role?.code === "MOHAD" ? (
          <MohUserManagement />
        ) : null}
      </Box>
    </Center>
  );
};

export default UserManagement;
